import { chainConfigs } from 'bzx-common/src/config/appConfig'
import { RootStore } from 'bzx-common/src/stores'
import { observer } from 'mobx-react'
import React from 'react'
import Picture from 'shared-components/Picture'
import { Icon } from 'ui-framework'
import ChainInfo from './ChainInfo'
import ProviderInfo from './ProviderInfo'

const genericWalletLogo = <Icon size={25} name="wallet-connect" />

export function OnChainIndicator({ rootStore }: { rootStore: RootStore }) {
  const { web3Connection, settings } = rootStore
  const {
    chainId,
    providerTypeDetails,
    isConnected,
    isDisconnecting,
    isLoadingWallet,
    hasProvider,
    impersonateAddress,
    shortWalletAddress,
  } = web3Connection

  const user = settings.users[web3Connection.connectedAddress]
  const alias = user ? user.alias : shortWalletAddress

  const ProviderLogoIcon = providerTypeDetails.ProviderLogo

  if (web3Connection.unsupportedNetwork) {
    return (
      <>
        <div className="btn-menu-square" data-tip data-for="chain-info" data-event="click focus">
          <i>Wrong Network!</i>
        </div>
        <ChainInfo />
      </>
    )
  }

  const chainLogo = chainId ? (
    <Icon
      name={chainConfigs[chainId].icon.name}
      color={chainConfigs[chainId].icon.color}
      size={25}
    />
  ) : (
    genericWalletLogo
  )

  if (!hasProvider) {
    return (
      <div className="flex-row-center">
        <div className="btn-menu-square" data-tip data-for="chain-info" data-event="click focus">
          {chainLogo}
        </div>
        <ChainInfo />
        <div
          className="btn-menu-square margin-left-1 on-chain-indicator--provider-button"
          data-tip
          data-for="provider-info"
          data-event="click focus">
          <div>Connect Wallet</div>
        </div>
        <ProviderInfo />
      </div>
    )
  }

  if (providerTypeDetails === null) {
    return (
      <>
        <div
          className="btn-menu-square on-chain-indicator--provider-button"
          data-tip
          data-for="provider-info"
          data-event="click focus">
          <div>Unknown provider</div>
        </div>
        <ProviderInfo />
      </>
    )
  }

  return (
    <div className="flex-row-center">
      <div className="btn-menu-square" data-tip data-for="chain-info" data-event="click focus">
        {chainLogo}
      </div>
      <ChainInfo />
      <div
        className="btn-menu-square margin-left-1 on-chain-indicator--provider-button"
        data-tip
        data-for="provider-info"
        data-event="click focus">
        <div className="flex-row-center">
          {impersonateAddress ? (
            <span className="txt-size-2">🕵️</span>
          ) : !isDisconnecting ? (
            user && user.avatar ? (
              <Picture
                src={`/images/avatars/${user.avatar}.png`}
                webp={`/images/avatars/${user.avatar}.webp`}
                className="on-chain-indicator--provider-alias icon-circle"
                width={32}
                height={32}
              />
            ) : (
              <ProviderLogoIcon className="on-chain-indicator--provider-logo" />
            )
          ) : null}

          <div className="margin-left-05 txt-subtitle-super on-chain-indicator--provider-text truncate">
            {isConnected && !isDisconnecting && <>{alias}</>}
            {isLoadingWallet && <>Connecting...</>}
            {isDisconnecting && <>Disconnecting...</>}
          </div>
        </div>
      </div>
      <ProviderInfo />
    </div>
  )
}

export default observer(OnChainIndicator)
